export default __webpack_public_path__ + "static/media/gold-dust-tea.7bafa596.png";